import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import Main from "./main";
import GlobalStateProvider from "../context/GlobalStateProvider";
import NotificationProvider from "../context/NotificationProvider";

ReactDOM.render(
	<React.StrictMode>
		<GlobalStateProvider>
			<NotificationProvider>
				<Main />
			</NotificationProvider>
		</GlobalStateProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
